import type { YasalBelge } from "../types"

import { SIRKET_BILGILERI as S } from "./sirket-bilgileri"

/**
 * Metin değiştiğinde versiyonu artır: kayıt formu ve paket talebi kabul kaydını
 * bu değerle gönderir, backend hangi metnin kabul edildiğini buradan bilir.
 */
export const KULLANIM_KOSULLARI_VERSIYON = "2026-10-25.1"

/**
 * Elektronik olarak (click-wrap) kabul edilir: kayıtta — Deneme Dönemi'ndeki
 * veri işlemeyi de kapsasın diye — ve ücretli pakete geçişte. Ek-1 Veri İşleme
 * Şartları (DPA) aynı kabulün parçasıdır.
 */
export const KULLANIM_KOSULLARI: YasalBelge = {
  baslik: "Kullanım Koşulları ve Abonelik Sözleşmesi",
  altBaslik: `${S.platformAdi} — Bulut Tabanlı Muhasebe Platformu · Ek-1 Veri İşleme Şartları dahil`,
  versiyon: KULLANIM_KOSULLARI_VERSIYON,
  tarih: "2026-10-25",
  bolumler: [
    {
      baslik: "Madde 1 – Taraflar",
      bloklar: [
        {
          tip: "fikra",
          no: "1.1",
          metin: `Hizmet Sağlayıcı: ${S.unvan} ("Hizmet Sağlayıcı" veya "${S.kisaAd}") — Adres: ${S.adres} — MERSİS No: ${S.mersisNo} — Vergi Dairesi / No: ${S.vergiDairesiNo} — E-posta: ${S.eposta} — KEP: ${S.kepAdresi}`,
        },
        {
          tip: "fikra",
          no: "1.2",
          metin: "Müşteri: Platform'a kayıt sırasında bildirilen ad soyad / unvan, e-posta adresi ve telefon bilgileriyle tanımlanan ve Hesap'ı açan gerçek veya tüzel kişi (\"Müşteri\"). Fatura için gereken vergi dairesi, VKN / T.C. kimlik no ve adres bilgileri Platform üzerinden ayrıca bildirilir.",
        },
        {
          tip: "fikra",
          no: "1.3",
          metin: "Hizmet Sağlayıcı ve Müşteri birlikte \"Taraflar\", ayrı ayrı \"Taraf\" olarak anılacaktır.",
        },
      ],
    },
    {
      baslik: "Madde 2 – Tanımlar",
      bloklar: [
        {
          tip: "liste",
          maddeler: [
            `Platform: ${S.alanAdi} alan adı üzerinden sunulan, ${S.platformAdi} adlı bulut tabanlı muhasebe, beyanname, bordro ve ilgili yazılım hizmeti.`,
            "Hesap: Müşteri adına Platform'da açılan ve Müşteri Kodu ile tanımlanan çalışma alanı.",
            "Kullanıcı: Müşteri'nin Hesap'ta yetkilendirdiği gerçek kişiler.",
            "Mükellef: Müşteri'nin Platform'da kaydını tuttuğu ve adına işlem yaptığı gerçek veya tüzel kişiler.",
            "Müşteri Verisi: Müşteri veya Kullanıcılar tarafından Platform'a girilen, yüklenen ya da Platform aracılığıyla üçüncü taraf sistemlerden alınan her türlü veri ve belge.",
            "Paket: Platform'da ilan edilen, kapsamı, kotaları ve bedeli belirlenmiş abonelik planı.",
            "Deneme Dönemi: Kayıttan itibaren başlayan, gerçek resmi gönderimlerin kapalı olduğu ücretsiz kullanım süresi.",
            "Sözleşme: Ek-1 Veri İşleme Şartları dahil bu Kullanım Koşulları ve Abonelik Sözleşmesi.",
            "Resmi Kurum Sistemleri: Gelir İdaresi Başkanlığı (GİB), Sosyal Güvenlik Kurumu (SGK), özel entegratörler, bankalar ve benzeri üçüncü taraf sistemler.",
          ],
        },
      ],
    },
    {
      baslik: "Madde 3 – Sözleşmenin Konusu",
      bloklar: [
        {
          tip: "fikra",
          no: "3.1",
          metin: "Bu Sözleşme'nin konusu; Hizmet Sağlayıcı'nın Platform'u Deneme Dönemi'nde ücretsiz olarak, sonrasında Müşteri'nin seçtiği Paket kapsamında ve bu Sözleşme'de belirtilen şartlarla Müşteri'nin kullanımına sunması ve Müşteri'nin buna karşılık Paket bedelini ödemesine ilişkin hak ve yükümlülüklerin belirlenmesidir.",
        },
        {
          tip: "fikra",
          no: "3.2",
          metin: "Platform bir yazılım hizmetidir. Hizmet Sağlayıcı; muhasebe, vergi veya hukuk danışmanlığı yapmaz, serbest muhasebeci mali müşavirlik mesleğini icra etmez ve Müşteri adına mesleki karar vermez.",
        },
      ],
    },
    {
      baslik: "Madde 4 – Hizmetin Kapsamı",
      bloklar: [
        {
          tip: "fikra",
          no: "4.1",
          metin: "Hizmetin kapsamı, kullanıcı / mükellef / personel kotaları ve özellikleri Müşteri'nin seçtiği Paket'e göre belirlenir ve Platform'daki paket ekranında ilan edilir. Paket değişikliği Müşteri'nin talebi ve Hizmet Sağlayıcı'nın onayı ile yapılır; Hesap'taki veriler paket değişikliğinden etkilenmez.",
        },
        {
          tip: "fikra",
          no: "4.2",
          metin: "Platform'un Resmi Kurum Sistemleri ile entegrasyon gerektiren özellikleri (e-beyanname, SGK bildirgeleri, e-fatura / e-defter vb.), ilgili sistemin erişilebilirliğine ve Müşteri'nin bu sistemler için sağladığı yetki, kullanıcı bilgisi, mali mühür / e-imza gibi araçlara bağlıdır.",
        },
        {
          tip: "fikra",
          no: "4.3",
          metin: "Hizmet Sağlayıcı, hizmetin kalitesini düşürmemek kaydıyla Platform'un özelliklerini, arayüzünü ve teknik altyapısını geliştirebilir ve değiştirebilir. Paket kapsamını Müşteri aleyhine daraltan değişiklikler, yürürlükteki abonelik dönemi sonuna kadar uygulanmaz.",
        },
      ],
    },
    {
      baslik: "Madde 5 – Deneme Dönemi",
      bloklar: [
        {
          tip: "fikra",
          no: "5.1",
          metin: "Kayıt olan Müşteri'ye 14 (on dört) günlük ücretsiz Deneme Dönemi tanınır. Deneme Dönemi'nde Resmi Kurum Sistemlerine gerçek gönderim yapılamaz; beyanname oluşturma, önizleme ve dosya indirme gibi işlemler kullanılabilir.",
        },
        {
          tip: "fikra",
          no: "5.2",
          metin: "Deneme Dönemi sonunda Paket'e geçilmezse Hesap askıya alınır. Askıdaki Hesap'ın verileri 30 (otuz) gün süreyle saklanır. Hizmet Sağlayıcı, bu sürenin sonunda verilerin silineceğini Müşteri'ye e-posta ile önceden bildirir; süre içinde Paket'e geçilmezse Müşteri Verisi Madde 14.2 uyarınca silinir.",
        },
      ],
    },
    {
      baslik: "Madde 6 – Ücret ve Ödeme",
      bloklar: [
        {
          tip: "fikra",
          no: "6.1",
          metin: "Paket bedeli, talep tarihinde Platform'da ilan edilen aylık bedeldir. İlan edilen bedellere KDV dahil değildir; bedel, yürürlükteki oranda KDV eklenerek faturalandırılır.",
        },
        {
          tip: "fikra",
          no: "6.2",
          metin: "Ödeme, Platform'daki Ödeme Bilgilerim ekranında gösterilen banka hesabına havale / EFT ile ve açıklama kısmına Müşteri Kodu yazılarak, abonelik dönemi başında peşin yapılır. Hizmet Sağlayıcı ödemenin ardından faturayı düzenler.",
        },
        {
          tip: "fikra",
          no: "6.3",
          metin: "Vadesinde yapılmayan ödemelerde Hizmet Sağlayıcı, vadeyi izleyen 7 (yedi) gün içinde Müşteri'ye e-posta ile ihtarda bulunur; ihtara rağmen ödeme yapılmazsa Hesap'ı askıya alabilir. Askı süresince Müşteri Verisi silinmez; ödemenin yapılmasıyla Hesap yeniden açılır.",
        },
        {
          tip: "fikra",
          no: "6.4",
          metin: "Hizmet Sağlayıcı Paket bedellerini, değişiklikten en az 30 (otuz) gün önce Müşteri'ye e-posta ile bildirmek kaydıyla değiştirebilir. Yeni bedel, bildirimden sonra başlayan ilk abonelik döneminden itibaren uygulanır. Müşteri yeni bedeli kabul etmezse, yeni dönem başlamadan Sözleşme'yi herhangi bir tazminat ödemeksizin dönem sonu itibarıyla feshedebilir.",
        },
      ],
    },
    {
      baslik: "Madde 7 – Müşteri'nin Yükümlülükleri",
      bloklar: [
        {
          tip: "fikra",
          no: "7.1",
          metin: "Müşteri, kayıt ve Sözleşme'de verdiği bilgilerin doğru ve güncel olduğunu, değişiklikleri Platform üzerinden veya yazılı olarak bildireceğini kabul eder.",
        },
        {
          tip: "fikra",
          no: "7.2",
          metin: "Müşteri; Hesap, şifre ve doğrulama kodlarının gizliliğinden, Kullanıcı yetkilendirmelerinden ve Hesap üzerinden yapılan tüm işlemlerden sorumludur. Yetkisiz kullanım şüphesini gecikmeksizin Hizmet Sağlayıcı'ya bildirir.",
        },
        {
          tip: "fikra",
          no: "7.3",
          metin: "Müşteri, Platform'da adına işlem yaptığı Mükellefler bakımından gerekli yetki, vekâlet ve sözleşmelere sahip olduğunu; Resmi Kurum Sistemleri için Platform'a tanımladığı kullanıcı bilgisi, şifre, mali mühür ve e-imza gibi araçları bu yetki kapsamında kullandığını kabul ve taahhüt eder.",
        },
        {
          tip: "fikra",
          no: "7.4",
          metin: "Platform'da hazırlanan beyanname, bildirge, fiş, rapor ve hesaplamaların Resmi Kurum Sistemlerine gönderilmeden önce kontrol edilmesi ve onaylanması Müşteri'nin sorumluluğundadır. Mesleki sorumluluk, 3568 sayılı Kanun ve ilgili mevzuat kapsamında Müşteri'ye aittir.",
        },
        {
          tip: "fikra",
          no: "7.5",
          metin: "Müşteri Platform'u hukuka aykırı amaçlarla kullanamaz; Platform'u kopyalayamaz, tersine mühendislik yapamaz, güvenlik önlemlerini aşmaya çalışamaz, Platform'a olağan dışı yük bindiren otomatik erişim yöntemleri kullanamaz ve Hesap'ı üçüncü kişilere kiralayamaz veya devredemez.",
        },
      ],
    },
    {
      baslik: "Madde 8 – Hizmet Sağlayıcı'nın Yükümlülükleri",
      bloklar: [
        {
          tip: "fikra",
          no: "8.1",
          metin: "Hizmet Sağlayıcı, Platform'u basiretli bir tacir özeniyle, yürürlükteki mevzuata uygun olarak sunar ve Platform'un güncel mevzuata uyumunu makul süre içinde sağlamak için gerekli özeni gösterir.",
        },
        {
          tip: "fikra",
          no: "8.2",
          metin: "Hizmet Sağlayıcı, Müşteri Verisi'nin güvenliği için KVKK md. 12 kapsamında gerekli teknik ve idari tedbirleri alır ve Müşteri Verisi'ni düzenli olarak yedekler.",
        },
        {
          tip: "fikra",
          no: "8.3",
          metin: "Planlı bakım çalışmaları, mümkün olduğunca mesai saatleri dışında ve önceden Platform üzerinden veya e-posta ile duyurularak yapılır.",
        },
        {
          tip: "fikra",
          no: "8.4",
          metin: `Hizmet Sağlayıcı, iş günlerinde ${S.eposta} adresi ve Platform'da ilan edilen kanallar üzerinden destek sağlar.`,
        },
      ],
    },
    {
      baslik: "Madde 9 – Sorumluluğun Sınırları",
      bloklar: [
        {
          tip: "fikra",
          no: "9.1",
          metin: "Hizmet Sağlayıcı, Platform'un kesintisiz ve hatasız çalışacağını taahhüt etmez. Resmi Kurum Sistemlerinin erişilemez olması, bu sistemlerdeki hata veya mevzuat değişiklikleri, internet altyapısı ve mücbir sebepler kaynaklı aksaklıklardan Hizmet Sağlayıcı sorumlu değildir.",
        },
        {
          tip: "fikra",
          no: "9.2",
          metin: "Müşteri'nin kontrol ve onay yükümlülüğünü (Madde 7.4) yerine getirmemesi, eksik veya hatalı veri girmesi ya da Resmi Kurum Sistemlerine ilişkin yetkilerini hatalı kullanması sonucu doğan vergi ziyaı, gecikme zammı, idari para cezası ve benzeri sonuçlardan Hizmet Sağlayıcı sorumlu tutulamaz.",
        },
        {
          tip: "fikra",
          no: "9.3",
          metin: "Hizmet Sağlayıcı'nın bu Sözleşme kapsamındaki toplam sorumluluğu, zararın doğduğu tarihten önceki 12 (on iki) ayda Müşteri'nin fiilen ödediği Paket bedelleri toplamı ile sınırlıdır. Dolaylı zararlar, kâr kaybı ve itibar kaybından sorumluluk kabul edilmez.",
        },
        {
          tip: "fikra",
          no: "9.4",
          metin: "Bu maddedeki sınırlamalar, Türk Borçlar Kanunu md. 115 uyarınca Hizmet Sağlayıcı'nın kast veya ağır ihmalinden doğan zararlara uygulanmaz.",
        },
      ],
    },
    {
      baslik: "Madde 10 – Fikri Mülkiyet",
      bloklar: [
        {
          tip: "fikra",
          no: "10.1",
          metin: "Platform'a ait yazılım, kaynak kod, tasarım, veri tabanı yapısı, marka ve logolar üzerindeki tüm fikri ve sınai haklar Hizmet Sağlayıcı'ya aittir. Müşteri'ye yalnızca Sözleşme süresince, Paket kapsamında, münhasır olmayan ve devredilemez bir kullanım hakkı tanınır.",
        },
        {
          tip: "fikra",
          no: "10.2",
          metin: "Müşteri Verisi Müşteri'ye aittir. Hizmet Sağlayıcı Müşteri Verisi'ni yalnızca hizmeti sunmak amacıyla ve bu Sözleşme'ye uygun olarak işler. Hizmetin geliştirilmesi amacıyla yalnızca kişiyi ve Müşteri'yi tanımlamayan, anonim hâle getirilmiş toplu istatistikler kullanılabilir.",
        },
        {
          tip: "fikra",
          no: "10.3",
          metin: "Müşteri'nin Madde 7.5'te sayılan kopyalama, tersine mühendislik ve güvenlik önlemlerini aşma yasaklarını ya da Madde 12'deki gizlilik yükümlülüğünü ihlal etmesi hâlinde Müşteri, ihlal tarihinde geçerli Paket bedelinin bir yıllık tutarının 3 (üç) katı tutarında cezai şartı Hizmet Sağlayıcı'ya ödemeyi kabul eder. Cezai şartın ödenmesi, Hizmet Sağlayıcı'nın aşan zararını talep hakkını ve ihlalin sona erdirilmesini isteme hakkını ortadan kaldırmaz.",
        },
      ],
    },
    {
      baslik: "Madde 11 – Kişisel Verilerin Korunması",
      bloklar: [
        {
          tip: "fikra",
          no: "11.1",
          metin: "Müşteri'nin ve Kullanıcıların hesap, iletişim ve ödeme verileri bakımından Hizmet Sağlayıcı veri sorumlusudur; bu veriler Platform'da yayımlanan Aydınlatma Metni'ne uygun olarak işlenir.",
        },
        {
          tip: "fikra",
          no: "11.2",
          metin: "Mükelleflere, Mükellef çalışanlarına ve cari hesaplara ait kişisel veriler bakımından Müşteri veri sorumlusu, Hizmet Sağlayıcı veri işleyendir. Taraflar bu verilerin işlenmesinde Ek-1 Veri İşleme Şartları'na uyar. Bu kişilerin aydınlatılması ve gerekli hâllerde açık rızalarının alınması Müşteri'nin yükümlülüğündedir.",
        },
      ],
    },
    {
      baslik: "Madde 12 – Gizlilik",
      bloklar: [
        {
          tip: "fikra",
          no: "12.1",
          metin: "Taraflar, Sözleşme nedeniyle birbirleri hakkında öğrendikleri ticari, mali ve teknik bilgileri ve Müşteri Verisi'ni gizli tutar; Sözleşme'nin ifası dışında kullanmaz ve kanuni zorunluluklar dışında üçüncü kişilere açıklamaz. Taraflar, çalışanlarının ve yardımcı kişilerinin bu yükümlülüğe uymasından sorumludur.",
        },
        {
          tip: "fikra",
          no: "12.2",
          metin: "Gizlilik yükümlülüğü, Sözleşme'nin sona ermesinden itibaren 5 (beş) yıl süreyle devam eder.",
        },
      ],
    },
    {
      baslik: "Madde 13 – Süre ve Fesih",
      bloklar: [
        {
          tip: "fikra",
          no: "13.1",
          metin: "Sözleşme, Müşteri'nin Platform'da elektronik olarak kabul etmesiyle yürürlüğe girer; Deneme Dönemi boyunca ve sonrasında Paket'in abonelik dönemi boyunca geçerlidir. Taraflardan biri dönem sonundan en az 15 (on beş) gün önce yazılı olarak veya Platform'da kayıtlı e-posta ile aksini bildirmedikçe, Sözleşme aynı süreyle kendiliğinden yenilenir.",
        },
        {
          tip: "fikra",
          no: "13.2",
          metin: "Taraflardan biri Sözleşme'den doğan esaslı yükümlülüklerini yerine getirmez ve yazılı bildirime rağmen ihlali 10 (on) iş günü içinde gidermezse, diğer Taraf Sözleşme'yi yazılı bildirimle feshedebilir.",
        },
        {
          tip: "fikra",
          no: "13.3",
          metin: "Taraflardan birinin iflası, konkordato talep etmesi veya borçlarını ödemede acze düşmesi hâlinde diğer Taraf Sözleşme'yi derhâl feshedebilir.",
        },
        {
          tip: "fikra",
          no: "13.4",
          metin: "Fesih, fesih tarihine kadar doğmuş ödeme yükümlülüklerini ortadan kaldırmaz. Müşteri'nin haklı nedenle feshinde, kullanılmayan döneme ilişkin peşin ödenmiş bedel iade edilir.",
        },
      ],
    },
    {
      baslik: "Madde 14 – Sözleşme Sona Erdiğinde Müşteri Verisi",
      bloklar: [
        {
          tip: "fikra",
          no: "14.1",
          metin: "Sözleşme'nin herhangi bir nedenle sona ermesinden itibaren 30 (otuz) gün süreyle Müşteri, Hesap'a salt okunur erişerek Müşteri Verisi'ni Platform'un sunduğu biçimlerde (Excel, XML, PDF vb.) dışa aktarabilir.",
        },
        {
          tip: "fikra",
          no: "14.2",
          metin: "Bu sürenin sonunda Müşteri Verisi, Hizmet Sağlayıcı'nın kanundan doğan saklama yükümlülükleri saklı kalmak kaydıyla kalıcı olarak silinir, yok edilir veya anonim hâle getirilir. Ticari defter ve belgelerin mevzuatta öngörülen süre boyunca saklanması Müşteri'nin sorumluluğundadır.",
        },
      ],
    },
    {
      baslik: "Madde 15 – Devir Yasağı",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Taraflar, bu Sözleşme'yi veya Sözleşme'den doğan hak ve alacaklarını diğer Taraf'ın yazılı onayı olmaksızın üçüncü kişilere devredemez ve temlik edemez. Hizmet Sağlayıcı'nın birleşme, bölünme veya tür değiştirme yoluyla külli halefiyeti bu yasağın kapsamı dışındadır.",
        },
      ],
    },
    {
      baslik: "Madde 16 – Bildirimler",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Sözleşme kapsamındaki bildirimler, Madde 1'de belirtilen adreslere yazılı olarak, KEP adreslerine veya Platform'da kayıtlı e-posta adreslerine yapılır. Adres değişikliği 7 (yedi) gün içinde diğer Taraf'a bildirilmedikçe eski adrese yapılan bildirimler geçerli sayılır.",
        },
      ],
    },
    {
      baslik: "Madde 17 – Delil Sözleşmesi",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Taraflar, Sözleşme'den doğabilecek uyuşmazlıklarda Hizmet Sağlayıcı'nın sistem ve işlem kayıtlarının — Sözleşme'nin kabul edildiği metin sürümü, kabulün tarih ve saati, IP adresi ve e-posta doğrulama kayıtları dahil —, e-posta yazışmalarının ve elektronik kayıtlarının 6100 sayılı Hukuk Muhakemeleri Kanunu md. 193 uyarınca delil teşkil edeceğini kabul eder; karşı delil sunma hakkı saklıdır.",
        },
      ],
    },
    {
      baslik: "Madde 18 – Uyuşmazlıkların Çözümü",
      bloklar: [
        {
          tip: "paragraf",
          metin: `Taraflar uyuşmazlıkları öncelikle dostane yollarla çözmeye çalışır. Dava açılmadan önce kanunen zorunlu olan hâllerde arabuluculuğa başvurulur. Sözleşme'den doğan uyuşmazlıklarda ${S.yetkiliMahkeme} Mahkemeleri ve İcra Daireleri yetkilidir.`,
        },
      ],
    },
    {
      baslik: "Madde 19 – Yürürlük",
      bloklar: [
        {
          tip: "fikra",
          no: "19.1",
          metin: "19 (on dokuz) madde ve Ek-1'den oluşan bu Sözleşme, Müşteri'nin Platform'a kayıt sırasında ve ücretli Paket'e geçişte ilgili onay kutucuğunu işaretleyerek elektronik olarak kabul etmesiyle kurulur; ayrıca imza gerekmez.",
        },
        {
          tip: "fikra",
          no: "19.2",
          metin: "Hizmet Sağlayıcı, Müşteri'nin kabul ettiği metin sürümünün bir nüshasını kalıcı veri saklayıcısıyla (PDF olarak, Platform'da kayıtlı e-posta adresine) Müşteri'ye iletir. Sözleşme'nin güncel ve önceki sürümlerine Platform üzerinden erişilebilir.",
        },
        {
          tip: "fikra",
          no: "19.3",
          metin: "Hizmet Sağlayıcı Sözleşme'yi değiştirdiğinde yeni sürüm, Müşteri'ye e-posta ile bildirilir ve Müşteri'nin Platform'da kabul etmesiyle yürürlüğe girer; Paket bedeline ilişkin değişikliklerde Madde 6.4 uygulanır.",
        },
      ],
    },
    {
      baslik: "Ek-1 – Veri İşleme Şartları (KVKK md. 12/2)",
      bloklar: [
        {
          tip: "fikra",
          no: "E1.1",
          metin: "Konu ve süre: Hizmet Sağlayıcı, Madde 11.2'de belirtilen kişisel verileri yalnızca Platform hizmetinin sunulması amacıyla ve Deneme Dönemi dahil Sözleşme süresince işler.",
        },
        {
          tip: "fikra",
          no: "E1.2",
          metin: "İlgili kişi grupları: Mükellefler (gerçek kişi mükellefler ve tüzel kişi mükelleflerin yetkilileri), Mükellef çalışanları, cari hesap kişileri.",
        },
        {
          tip: "fikra",
          no: "E1.3",
          metin: "Veri kategorileri: kimlik (T.C. kimlik no dahil), iletişim, özlük ve bordro verileri, SGK kayıtları, finansal veriler ve fatura bilgileri. Bordro ve puantaj kapsamında engellilik derecesi ile istirahat / rapor kayıtları gibi sağlık verileri (özel nitelikli kişisel veri) de işlenebilir; bu veriler için Kurul'un özel nitelikli veriler hakkındaki kararında belirtilen ek güvenlik önlemleri uygulanır.",
        },
        {
          tip: "fikra",
          no: "E1.4",
          metin: "Talimata bağlılık: Hizmet Sağlayıcı verileri Müşteri'nin Platform'u kullanarak verdiği talimatlar ve bu Sözleşme dışında işlemez, kendi amaçları için kullanmaz.",
        },
        {
          tip: "fikra",
          no: "E1.5",
          metin: "Gizlilik ve güvenlik: Verilere erişen personel gizlilik yükümlülüğü altındadır. Hizmet Sağlayıcı; iletimde ve depolamada şifreleme, iki faktörlü kimlik doğrulama, yetki ve erişim kontrolü, erişim kayıtları, yedekleme ve sızma testleri gibi teknik ve idari tedbirleri uygular.",
        },
        {
          tip: "fikra",
          no: "E1.6",
          metin: "Alt veri işleyenler: Hizmet Sağlayıcı, barındırma ve altyapı hizmetleri için alt veri işleyenlerden yararlanabilir. Güncel liste: [●]. Yeni bir alt veri işleyen, Müşteri'ye önceden bildirilir ve Müşteri'nin haklı itiraz hakkı saklıdır. Yurt dışına aktarım yalnızca KVKK md. 9'daki güvencelerle yapılır.",
        },
        {
          tip: "fikra",
          no: "E1.7",
          metin: "Veri ihlali: Hizmet Sağlayıcı, kişisel veri ihlalini öğrenmesinden itibaren gecikmeksizin ve en geç 24 (yirmi dört) saat içinde Müşteri'ye bildirir; Müşteri'nin Kurul'a ve ilgili kişilere bildirim yükümlülüğünü yerine getirmesi için gerekli bilgileri sağlar.",
        },
        {
          tip: "fikra",
          no: "E1.8",
          metin: "İlgili kişi talepleri: Hizmet Sağlayıcı, ilgili kişilerin KVKK md. 11 kapsamındaki taleplerinin Müşteri tarafından yanıtlanmasına makul ölçüde yardımcı olur; kendisine doğrudan ulaşan talepleri Müşteri'ye yönlendirir.",
        },
        {
          tip: "fikra",
          no: "E1.9",
          metin: "Sona erme: Sözleşme sona erdiğinde veriler Madde 14 uyarınca Müşteri'ye dışa aktarım imkânı tanındıktan sonra silinir veya anonim hâle getirilir.",
        },
        {
          tip: "fikra",
          no: "E1.10",
          metin: "Denetim: Müşteri, makul bir süre önceden bildirmek ve gizlilik yükümlülüğüne uymak kaydıyla, Hizmet Sağlayıcı'nın bu Ek'e uyumuna ilişkin bilgi ve belge talep edebilir.",
        },
      ],
    },
  ],
}
